import { UploadTexts } from '../../../language/Texts';
import { GeneralAttributes } from '../../../models/GeneralAttributes';
import { RequestPaths } from '../../../models/RequestPaths';
import { UploadProps } from '../../../models/UploadProps';
import BoxComponent from '../../BoxComponent/BoxComponent';

const ConexoUploadGea = ({ manufacturer, setConexoResponse, setLoading, loading, resetSession }: UploadProps) => {
    const url = RequestPaths.saveInConexoPathGea

    return (
        <>
            {manufacturer === GeneralAttributes.gea &&
                <BoxComponent
                    boxTitle={UploadTexts.qrCodeScannenGea}
                    setConexoResponse={setConexoResponse}
                    inputType='url'
                    placeholder={UploadTexts.inputIdLink}
                    buttonText={UploadTexts.saveInConexo}
                    setLoading={setLoading}
                    loading={loading}
                    requestUrl={url}
                    resetSession={resetSession}
                />
            }
        </>
    )
}

export default ConexoUploadGea